export default __webpack_public_path__ + "static/logo-097ce1a7de5b45cdf03506acbe6b2c7d.svg";